import { NavLink, Outlet } from 'react-router-dom';

/** Top-level navigation items. */
const NAV = [
  { to: '/', label: 'Urządzenia', end: true },
  { to: '/requests', label: 'Żądania' },
  { to: '/logs', label: 'Logi' },
];

/**
 * Application shell: header, primary navigation and the routed page outlet.
 */
export function Layout() {
  return (
    <div className="app">
      <header className="app__header">
        <div className="app__brand">
          <span className="app__logo">◆</span>
          <div>
            <h1>Kontroler+ LogFetcher</h1>
            <p>Zdalne pobieranie logów z urządzeń mobilnych</p>
          </div>
        </div>
        <nav className="app__nav">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => (isActive ? 'nav-link nav-link--active' : 'nav-link')}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="app__main">
        <Outlet />
      </main>
    </div>
  );
}
